import { render, staticRenderFns } from "./BalcaoPedidoItens.vue?vue&type=template&id=0dedc0ab&scoped=true&"
import script from "./BalcaoPedidoItens.vue?vue&type=script&lang=js&"
export * from "./BalcaoPedidoItens.vue?vue&type=script&lang=js&"
import style0 from "./BalcaoPedidoItens.vue?vue&type=style&index=0&id=0dedc0ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedc0ab",
  null
  
)

export default component.exports